import { Trans } from "@lingui/react";
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectDocumentOid } from '../../../store';
import { referralActions } from '../../../store/actions/referral';
import { viewLinkActions } from '../../../store/actions/viewLinkActions';
import { Dumb } from '..';
import { Fonts } from '@prezi/dragon';
import SectionTitle from '../dumb/SectionTitle';
const Wrapper = styled.div.withConfig({
  displayName: "ViewLinkCopy__Wrapper",
  componentId: "sc-1naks6t-0"
})(["", ""], props => props.hasPadding ? 'padding-top: 16px' : '');
const DescriptionWrapper = styled.span.withConfig({
  displayName: "ViewLinkCopy__DescriptionWrapper",
  componentId: "sc-1naks6t-1"
})(["font-size:12px;display:block;color:rgba(56,66,80,1);font-weight:500;font-family:", ";padding-top:8px;"], Fonts.ralewaySemiBold);
const ViewLinkCopy = ({
  isShareLinkImprovementsActive
}) => {
  const dispatch = useDispatch();
  const unifiedPrivacy = useSelector(state => state.unifiedPrivacy.value);
  const referralState = useSelector(state => state.referral);
  const showReferralInfo = useSelector(state => state.showReferralCopyAndCode);
  const documentOid = useSelector(selectDocumentOid);
  const creditsAmount = 200;
  React.useEffect(() => {
    dispatch(referralActions.getReferralData('B3FN'));
  }, []);
  if (unifiedPrivacy) {
    var _referralState$value, _referralState$value$;
    let viewLink = unifiedPrivacy.view_link || unifiedPrivacy.default_link;
    if (showReferralInfo && (referralState === null || referralState === void 0 ? void 0 : (_referralState$value = referralState.value) === null || _referralState$value === void 0 ? void 0 : (_referralState$value$ = _referralState$value.tokens) === null || _referralState$value$ === void 0 ? void 0 : _referralState$value$.ln)) {
      viewLink = viewLink + '?referral_token=' + encodeURIComponent(referralState.value.tokens.ln);
    }
    return React.createElement(Wrapper, {
      hasPadding: !isShareLinkImprovementsActive
    }, isShareLinkImprovementsActive ? React.createElement(SectionTitle, null, React.createElement(Trans, {
      id: "Share link"
    })) : null, React.createElement(Dumb.ViewLinkCopyPrimary, {
      viewLink: viewLink,
      handleCopyToClipboard: () => dispatch(viewLinkActions.copyToClipboard(viewLink)),
      isSingleLineLink: isShareLinkImprovementsActive,
      documentId: documentOid
    }), showReferralInfo && React.createElement(DescriptionWrapper, null, isShareLinkImprovementsActive ? React.createElement(Trans, {
      id: "Links include invitation to Prezi and you'll both get <0>{creditsAmount} AI credits</0> when your friends sign up.",
      values: {
        creditsAmount: creditsAmount
      },
      components: {
        0: React.createElement("u", null)
      }
    }) : React.createElement(Trans, {
      id: "Invite your friends to Prezi and you'll both get <0>{creditsAmount} AI credits</0> when they sign up using your link or email invite.",
      values: {
        creditsAmount: creditsAmount
      },
      components: {
        0: React.createElement("u", null)
      }
    })));
  }
  return null;
};
export default ViewLinkCopy;